import { ApiLeadStatusRule } from "@incendium/api";
import { Box, CircularProgress } from "@mui/material";
import { leadStatusService } from "Apis";
import ConditionGroupProvider from "Components/ConditionalGroup/ConditionGroupProvider";
import LeadStatusRuleForm from "features/funnel/components/LeadStatusRuleForm";
import { useMount, useProjectSelector } from "Hooks";
import { useConversions } from "Hooks/useConversions";
import { useLeadStatusRules } from "Hooks/useLeadStatusRules";
import { useState, useMemo } from "react";
import { useParams } from "react-router-dom";

function LeadPage() {
  const project = useProjectSelector();
  const { leadStatusRuleId } = useParams<{ leadStatusRuleId: string }>();
  const [leadStatusRule, setLeadStatusRule] = useState<
    ApiLeadStatusRule | undefined
  >(undefined);
  const { conversions } = useConversions();
  const { leadStatusRules } = useLeadStatusRules();
  useMount(() => {
    if (!leadStatusRuleId) {
      return;
    }
    const load = async () => {
      const res = await leadStatusService.leadStatusServiceReadLeadStatusRule({
        projectId: project?.id as number,
        leadStatusRuleId: Number(leadStatusRuleId),
      });
      setLeadStatusRule(res);
    };
    load();
  });

  const filteredConversions = useMemo(() => {
    return [...conversions];
  }, [leadStatusRule, conversions]);

  if (!project || !leadStatusRule) {
    return <CircularProgress />;
  }

  return (
    <Box mt={5}>
      <ConditionGroupProvider>
        <LeadStatusRuleForm
          leadStatusRule={leadStatusRule}
          setLeadStatusRule={setLeadStatusRule}
          project={project}
          conversions={filteredConversions}
          ledStatusRules={leadStatusRules}
        />
      </ConditionGroupProvider>
    </Box>
  );
}

export default LeadPage;
